import axios from '../config/axiosConfig';

const API_URL = '/owasp-wstg';

const getAll = async (params = {}) => {
  const response = await axios.get(API_URL, { params });
  return response.data;
};

const getCategories = async () => {
  const response = await axios.get(`${API_URL}/categories`);
  return response.data;
};

const getByTestId = async (testId) => {
  const response = await axios.get(`${API_URL}/${testId}`);
  return response.data;
};

const getByMitreMapping = async (techniqueId) => {
  const response = await axios.get(`${API_URL}/mitre-mapping/${techniqueId}`);
  return response.data;
};

// Category display config
const categoryConfig = {
  'WSTG-INFO': { name: 'Information Gathering', color: 'blue', icon: 'search' },
  'WSTG-CONF': { name: 'Configuration & Deployment', color: 'gray', icon: 'cog' },
  'WSTG-IDNT': { name: 'Identity Management', color: 'purple', icon: 'id-card' },
  'WSTG-ATHN': { name: 'Authentication', color: 'green', icon: 'key' },
  'WSTG-ATHZ': { name: 'Authorization', color: 'yellow', icon: 'lock' },
  'WSTG-SESS': { name: 'Session Management', color: 'orange', icon: 'clock' },
  'WSTG-INPV': { name: 'Input Validation', color: 'red', icon: 'shield-alt' },
  'WSTG-ERRH': { name: 'Error Handling', color: 'pink', icon: 'exclamation-triangle' },
  'WSTG-CRYP': { name: 'Weak Cryptography', color: 'indigo', icon: 'lock-open' },
  'WSTG-BUSL': { name: 'Business Logic', color: 'teal', icon: 'sitemap' },
  'WSTG-CLNT': { name: 'Client-side', color: 'cyan', icon: 'desktop' },
  'WSTG-APIT': { name: 'API Testing', color: 'lime', icon: 'plug' }
};

const getCategoryConfig = (code) => categoryConfig[code] || { name: code, color: 'gray', icon: 'question' };

const owaspWstgService = {
  getAll,
  getCategories,
  getByTestId,
  getByMitreMapping,
  categoryConfig,
  getCategoryConfig
};

export default owaspWstgService;
